export const MUSIC_MOODS = [
  { value: "explore", label: "Exploration" },
  { value: "tavern", label: "Tavern / Town" },
  { value: "dungeon", label: "Dungeon" },
  { value: "combat", label: "Combat" },
  { value: "boss", label: "Boss Fight" },
  { value: "victory", label: "Victory" },
  { value: "tense", label: "Tense / Suspense" },
];

export const SFX_TAGS = [
  { value: "attack_hit", label: "Attack — Hit" },
  { value: "attack_miss", label: "Attack — Miss" },
  { value: "attack_crit", label: "Attack — Critical" },
  { value: "spell_cast", label: "Spell Cast" },
  { value: "footstep", label: "Footstep" },
  { value: "door", label: "Door" },
  { value: "chest_open", label: "Chest Open" },
  { value: "monster_growl", label: "Monster — Growl" },
  { value: "monster_attack", label: "Monster — Attack" },
  { value: "damage_taken", label: "Damage Taken" },
  { value: "death", label: "Death" },
  { value: "ko", label: "Knocked Out" },
  { value: "level_up", label: "Level Up" },
  { value: "dice_roll", label: "Dice Roll" },
  { value: "legendary_loot", label: "Legendary Loot Chime" },
];
